import { AxiosRequestConfig } from "axios";

import { trackPromoCodeApplySubmitted } from "utils/Tracking";
import { addToasterActionData } from "hooks/useToasterFromActionData";
import scraperApi, { ApiError, ApiErrorResponse } from "api";
import { ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";


type AddCouponsActionArgs = {
  couponCodes: string[],
  targetPlanSlug?: string;
};

export const addCouponsAction: (args: AddCouponsActionArgs, opts?: AxiosRequestConfig) => ReturnType<NonNullable<ActiveCouponsDataRouteType["route"]["action"]>> =
  async ({ couponCodes, targetPlanSlug }, opts) => {
    try {
      couponCodes.forEach(trackPromoCodeApplySubmitted);

      const activeCoupons = await scraperApi.billing.coupons.addCoupons(couponCodes, targetPlanSlug, opts);
      return addToasterActionData(
        { activeCoupons },
        {
          toastId: "promo-code-applied",
          type: "success",
          title: "Promo Code Applied",
          description: "Your promo code has been successfully applied to your subscription."
        }
      );
    } catch (err) {
      const error = err as ApiError<ApiErrorResponse>;
      return addToasterActionData(
        { error: { message: error.message || "Failed to apply coupon" } },
        {
          toastId: "add-coupon-error",
          type: "error",
          title: "Coupon Error",
          description: error.message || "Failed to apply coupon"
        }
      );
    }
  };
